import { colors } from "@mui/material";

const MuiButton = {
	styleOverrides: {
		contained: {
			boxShadow: "0 1px 1px 0 rgba(0,0,0,0.14)",
			backgroundColor: colors.grey[100],
			"&:hover": {
				backgroundColor: colors.grey[300],
			},
		},
		containedPrimary: {
			backgroundColor: colors.lightBlue[900],
			color: "#fff",
			"&:hover": {
				backgroundColor: colors.lightBlue[800],
			},
		},
	},
};
export default MuiButton;
